import React from 'react';
import { Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { EnhancedTableSectionProps } from './types';
import { LABELS } from './constants';
import { SectionCard, SectionHeader, SectionTitle, ViewAllButton } from './styles';

type TableRow = Record<string, string | boolean | number>;

const EnhancedTableSection: React.FC<EnhancedTableSectionProps> = ({
  isOpen,
  data,
  columns,
  title,
  isLoading,
}) => {
  if (!isOpen) return null;

  const tableColumns: ColumnsType<TableRow> = columns.map((col, index) => {
    const dataKey = Object.keys(data[0] || {})[index] || col;
    return {
      title: col,
      dataIndex: dataKey,
      key: dataKey,
      render: (value: string | boolean) => {
        if (typeof value === 'boolean') {
          return (
            <Tag color={value ? 'success' : 'error'} bordered={false}>
              {value ? LABELS.ACTIVE : LABELS.INACTIVE}
            </Tag>
          );
        }
        return value;
      },
    };
  });

  return (
    <SectionCard>
      <SectionHeader>
        <SectionTitle>{title}</SectionTitle>
        <ViewAllButton type="primary" ghost>
          {LABELS.VIEW_ALL}
        </ViewAllButton>
      </SectionHeader>
      <Table<TableRow>
        columns={tableColumns}
        dataSource={data.slice(0, 5).map((item, i) => ({ ...item, key: i }))}
        pagination={false}
        loading={isLoading}
        size="middle"
      />
    </SectionCard>
  );
};

export default EnhancedTableSection;
